import { render } from "./deleteService.vue?vue&type=template&id=4dfa5e8c&scoped=true"
import script from "./deleteService.vue?vue&type=script&lang=js"
export * from "./deleteService.vue?vue&type=script&lang=js"

import "./deleteService.vue?vue&type=style&index=0&id=4dfa5e8c&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfa5e8c"]])

export default __exports__